import { ErrorDetails } from  '@/interfaces/LockerManagement'
import { download, getFileTimeStamp } from  '@/helpers/Files';
import React from 'react'

interface LockerEventIssueProps {
    id: number
    issue: ErrorDetails
    resolveError: (id: number, errorCode: number ) => void
    isResolved: boolean
    fileName: string
} 

const LockerEventIssue = ({id, issue, resolveError, isResolved, fileName}: LockerEventIssueProps) => {

    const {issueDescription, issueCount, lockerIntentFileDeliveryRequestDetailedStatus: status, batchId} = issue

    function getShortenedIssueDescription(issueDescription: string) {
        return issueDescription.includes('Rejected files')
            ? 'Rejected files'
            : issueDescription;
    }
    return (
        <div key={id} className="issue-wrapper">
        <div className="issue-titles">
            <h4>{getShortenedIssueDescription(issueDescription)}</h4>
            <h4 className={!isResolved ? 'warning' : 'success'}>
                {!isResolved  ? `${issueCount} Failures` : 'Resolved'}
            </h4>
        </div>
        {!isResolved  &&
        <div className="resolve-issues-button-wrapper">
            <button
                aria-label={`resolve ${getShortenedIssueDescription(issueDescription)}`}
                className="btn-blue"
                onClick={()=>{
                    resolveError(batchId, status);
                }}
            >
                Resolve
            </button>
            <button className="btn-clear" onClick={()=> {
                download(
                    `../../api/locker/batches/${batchId}/errors/${status}/download`,
                    `${fileName}_LockerBatchFailuresReport_${getFileTimeStamp()}`
                )
                
            }}>
                Download Errors
            </button>
        </div>
        }
    </div>
    )
}

export default LockerEventIssue